<template>
  <div>
    <list
      row-key="OtherReceivId"
      ref="list"
      unit="其他应收单"
      light-row
      @row-select="x=>$emit('change',x)"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      :summaryMethod="summaryFunc"
      :show-summary="summaryShow"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="业务类型">
          <business-select
            v-model="params.BusinessTypeId"
            :params="{Kind:'应收',SourceType:'其他应收单'}"
          />
        </el-form-item>
        <el-form-item label="单据日期" v-if="!isMB">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item>
        <el-form-item label="往来单位">
          <!-- <select-input
            placeholder="请选择单位"
            :label="params.TradeUnitName"
            v-model="params.TradeUnitId"
            @click="openTradeunit"
          /> -->
          <customer @restaurants="setSupplier" :state="params.TradeUnitName" :typeList="[1, 3]" />
        </el-form-item>
        <el-form-item label="单据日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择结束时间"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" min-width="150" show-overflow-tooltip />
        <el-table-column prop="DocDate" label="单据日期" min-width="100">
          <template slot-scope="{row}">{{ $commonJs.toDateString(row.DocDate) }}</template>
        </el-table-column>
        <el-table-column prop="BusinessType" label="业务类型" min-width="100" />
        <el-table-column prop="LastDate" label="收款到期日" min-width="100">
          <template slot-scope="{row}">{{ $commonJs.toDateString(row.LastDate) }}</template>
        </el-table-column>
        <el-table-column prop="TradeUnitName" label="往来单位" min-width="130" show-overflow-tooltip />
        <el-table-column prop="Amount" label="金额" />
        <el-table-column prop="ClerkName" label="经办人" min-width="100" />
        <el-table-column prop="Status" label="单据状态" width="100px">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-if="row.Status==1">未生效</span>
            <span v-if="row.Status==2">已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="140" show-overflow-tooltip />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import businessSelect from "@/components/basedoc/business/select";
import tradeunitDialog from "@/components/basicinfo/basic/logistics/listDialog";

export default {
  mixins: [listMixin],
  components: { list, businessSelect, tradeunitDialog,customer },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/fund/contactcash/orec").default,
      params: {
        TradeUnitId: null,
        TradeUnitName: "",
        BusinessTypeId: null,
        DocNo: "",
        DocDateStart: this.$commonJs.getToday(),
        DocDateEnd: this.$commonJs.getToday(),
      },
      isMB: this.$store.state.isMB,
      summaryShow: false,
      total:null
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.listTotal(params).then(res => {
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    summaryFunc(param) {
      const { columns, data } = param;
      var fields = ['Amount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    setSupplier(data) {
      
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.TradeUnitName;
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.Id;
      this.params.TradeUnitName = data.Name;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>